module.exports = __webpack_public_path__ + "img/logo-rtcbq.8cc69829.png";